import * as React from 'react';
import styled, {css} from 'styled-components';
import {omit} from 'lodash';
import {transition} from 'helpers/css';
import {RadioProps} from 'components/Radio';

export interface RadioButtonProps extends RadioProps {
  stretched?: boolean;
}

const Label = styled.label`
  display: inline-grid;
  user-select: none;
`;

const Radio = styled.div`
  padding: 7px 12px;
  background: ${({theme}) => theme.variables.backgroundColor};
  cursor: pointer;
  
  &:hover,
  &:focus {
    background: ${({theme}) => theme.variables.borderColor};
  }
`;

const Container = styled.div<Pick<RadioButtonProps, | 'stretched'>>`
  font-size: 12px;
  font-weight: 500;
  border-radius: 5px;
  overflow: hidden;

  ${transition()};
  
  ${({stretched}) => {
    return stretched && css`
      border-radius: 0;
      &:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }

      &:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    `;
  }}
`;

const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0,0,0,0);

  &:checked + ${Radio} {
    background: ${({theme}) => theme.colors.primary};
  }
`;

/**
 * The component render button type radio
 * @param {RadioProps} props
 * @return {JSX.Element}
 */
export default function RadioButton(props: RadioButtonProps) {
  const radioProps = omit(props, 'label', 'type', 'stretched');

  return (
    <Container stretched={props.stretched}>
      <Label>
        <HiddenInput
          type="radio"
          {...radioProps}
        />
        <Radio>
          {props.label}
        </Radio>
      </Label>
    </Container>
  );
};
